import apigeeIntegration from "./self-service-adapter";
import Analytics from "@telenornorgeinternal/frontend-analytics";

const api = apigeeIntegration("/mobile-order/v2");

const getOrderWithoutBankId = (orderObject) => {
	return orderObject; // this function is redundant now and should be removed
};

const getSummary = async (orderObject) =>
	api.post("/order/validate", getOrderWithoutBankId(orderObject), {
		headers: {
			"x-telenor-dealer-id": 6662, // fix for system user issue right now,
		},
		cache: { override: true },
		timeout: 1000 * 50,
	});

const sendOrder = async (orderObject) => {
	return api.post("/order", getOrderWithoutBankId(orderObject), {
		headers: {
			"x-telenor-dealer-id": 6662, // fix for system user issue right now
		},
		cache: { override: true },
		timeout: 60000,
	});
};

const validateOrder = async (order) => {
	return await api.post("/order/validate", order, {
		headers: {
			"x-telenor-dealer-id": 6662, // fix for system user issue right now
		},
		cache: { override: true },
		timeout: 1000 * 50,
	});
};

const softCreditCheck = async () => {
	return await api.get("/creditcheck/soft", {
		headers: {
			"x-telenor-dealer-id": 6662,
		},
		cache: { override: true },
	});
};

const reserveNumbers = () =>
	api
		.get("/numbers/reserve?accessType=VOICE&amount=3", {
			headers: {
				"x-telenor-dealer-id": 6662, // fix for system user issue right now
				"x-telenor-channel-name": "MTW",
			},
			cache: { override: true },
		})
		.then((response) => {
			Analytics.TnAnalytics.track("Mobile_MobileOrder_ReserveNumbers", {
				component: "NewNumber",
				place: "getNumbers()",
				loggedIn: true,
			});

			return response;
		})
		.catch((axiosError) => {
			Analytics.TnAnalytics.track("Mobile_MobileOrder_ReserveNumbers_Error", {
				file: "integrations/mobile-order.js",
				place: "reserveNumbers()",
				requestId: axiosError.response?.data?.requestId,
				error: JSON.stringify({
					stack: axiosError.stack,
					message: axiosError.message,
					response: {
						...axiosError.response,
						headers: {
							...axiosError.response.headers,
							Authorization: "***",
						},
						config: {
							...axiosError.response.config,
							headers: {
								...axiosError.response.config.headers,
								Authorization: "***",
							},
						},
					},
				}),
			});
		});

const reserveNumbersForProduct = (productId) =>
	api.get(`/numbers/reserve?productId=${productId}&amount=1`, {
		headers: {
			"x-telenor-dealer-id": 6662, // fix for system user issue right now
			"x-telenor-channel-name": "MTW",
		},
		cache: { override: true },
	});

const validPortTimes = (withPostageTime) =>
	api.get(`/order/validporttimes?withPostageTime=${withPostageTime}`, {
		headers: {
			"x-telenor-dealer-id": 6662, // fix for system user issue right now
		},
		cache: { override: true },
	});

const getQrCodesForOrderId = (orderId) =>
	api.get(`/esim/orderId/${orderId}/qrcodes`, {
		headers: {
			"Content-Type": "application/json",
			"x-telenor-dealer-id": 6662, // fix for system user issue right now
		},
		cache: { override: true },
	});

export default {
	getSummary,
	sendOrder,
	validateOrder,
	softCreditCheck,
	reserveNumbers,
	reserveNumbersForProduct,
	validPortTimes,
	getQrCodesForOrderId,
};
